import * as React from 'react';
export const IcRemotePush = (
  props: React.SVGProps<SVGSVGElement>
): JSX.Element => (
  <svg
    viewBox='0 0 24 24'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    {...props}
  >
    <path
      d='M17.12 2.88A3 3 0 0015 2H9a3 3 0 00-3 3v14a3 3 0 003 3h6a3 3 0 003-3V5a3 3 0 00-.88-2.12zM9 8h6l-3 1.83L9 8zm3.88 11.63A1.218 1.218 0 0112 20a1.25 1.25 0 01-1.15-.77 1.27 1.27 0 01-.08-.72 1.3 1.3 0 011-1 1.27 1.27 0 011.279.539 1.25 1.25 0 01.113 1.175 1.22 1.22 0 01-.282.406zM16 13a1 1 0 01-1 1H9a1 1 0 01-1-1V9.77l3.49 2.09a1 1 0 001 0L16 9.77V13z'
      fill='currentColor'
    />
  </svg>
);
